import { render } from "./StepNumber.vue?vue&type=template&id=a564590c"
import script from "./StepNumber.vue?vue&type=script&lang=js"
export * from "./StepNumber.vue?vue&type=script&lang=js"

import "./StepNumber.vue?vue&type=style&index=0&id=a564590c&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__